export const SCHOOL_CONTACT_EVENT_TYPES = [
  'usedContactForm',
  'usedCallOnPhone',
  'usedSocialMedia',
] as const

export type SchoolContactEventType = (typeof SCHOOL_CONTACT_EVENT_TYPES)[number]

interface TrackSchoolContactParams {
  schoolId: string
  eventType: SchoolContactEventType
}

export async function trackSchoolContact({
  schoolId,
  eventType,
}: TrackSchoolContactParams): Promise<void> {
  try {
    await fetch('/api/school-contact-analytics', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ schoolId, eventType }),
    })
  } catch {
    // Analytics failure should never block UI
  }
}
